import styled from '@emotion/styled'
import { transparentize } from 'polished'

import { BorderRadius } from '../../enums/borderRadius'
import { Color } from '../../enums/color'
import { Spacing } from '../../enums/spacing'
import { NotificationVariant } from './types'
import { variantStyles } from './utils'

interface NotificationWrapperProps {
  clickable?: boolean
  isFullWidth?: boolean
  variant: NotificationVariant
  withCloseButton: boolean
}

export const NotificationWrapper = styled.div<NotificationWrapperProps>`
  display: flex;
  width: fit-content;
  max-width: ${({ isFullWidth }) => (isFullWidth ? '100%' : '600px')};
  min-height: 56px;
  padding: ${({ withCloseButton }) =>
    withCloseButton ? `${Spacing.S12} ${Spacing.S8}` : `${Spacing.S12} ${Spacing.S16} ${Spacing.S12} ${Spacing.S8}`};
  border-radius: ${BorderRadius.R12};
  background-color: ${({ variant }) => variantStyles[variant].bgColor};
  /* TODO retheming 2026 - when the shadows from the DS are ready, use the appropriate one. */
  box-shadow: ${transparentize(0.85, Color.Black)} 0px 4px 12px;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'initial')};
`

export const Content = styled.div`
  display: flex;
  margin-top: ${Spacing.S4};
`

export const BodyContent = styled.div``

export const IconWrapper = styled.div`
  display: flex;
  margin-right: ${Spacing.S8};
  margin-left: ${Spacing.S8};
  padding-top: ${Spacing.S4};
`

export const SideActions = styled.aside`
  margin-top: ${Spacing.S8};
`

export const CloseIconWrapper = styled.div`
  align-self: flex-start;
  margin-left: ${Spacing.S8};
`
